import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Form, Input} from 'semantic-ui-react';
import {dateFormatPicker} from '../../../common/constants/datesFormat';

const FormDealereWaitHappy = ({detail, deliveryDateReal, handleChange}) => {
  const {reserveDate, arrivalFromTde, arrivalToTde} = detail;

  function verifyData(data) {
    return data ? data : '';
  }
  
  return (
    <React.Fragment>
      <Form.Group widths='three'>
        <Form.Field
          control={Input}
          label='Fecha de reserva'
          value={verifyData(reserveDate)}
          placeholder='Fecha de reserva'
        />
        <Form.Field
          control={Input}
          label='Fecha de llegada TDE'
          value={verifyData(arrivalToTde)}
          placeholder='Fecha de llegada TDE'
        />
        <Form.Field
          control={Input}
          label='Fecha de entrega TDE'
          value={verifyData(arrivalFromTde)}
          placeholder='Fecha de entrega TDE'
        />
      </Form.Group>
      <Form.Group widths='three'>
        <Form.Input fluid label='Fecha de facturación al cliente  '>
          <DatePicker
            placeholderText='Fecha de facturación al cliente  '
            className='tcc-datepicker'
            selected={deliveryDateReal ? moment(deliveryDateReal).toDate() : null}
            onChange={(value) => handleChange('deliveryDateReal', value)}
            dateFormat={dateFormatPicker}
            locale='es'
          />
        </Form.Input>
      </Form.Group>
    </React.Fragment>
  );
};

export default FormDealereWaitHappy;
